// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MyProfile_wrapper__2LGB4","actions":"MyProfile_actions__1gerg"};